var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-wrap"},_vm._l((_vm.messages),function(message,index){return _c('p',{key:index,class:['msg-wrap',message.values.type]},[_vm._v(" "+_vm._s(message.values.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }